export const SectionQ = {
    m2401: {
        version: ['e1'],
        timepoint: ['tr', 'trd', 'dsch'],
    },
};
// Q-M2401_INTRVTN_SMRY_DPRSN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"No"},{"value":"01","label":"Yes"},{"value":"NA","label":"Not applicable"}]
// Q-M2401_INTRVTN_SMRY_FALL_PRVNT-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"No"},{"value":"01","label":"Yes"},{"value":"NA","label":"Not applicable"}]
// Q-M2401_INTRVTN_SMRY_PAIN_MNTR-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"No"},{"value":"01","label":"Yes"},{"value":"NA","label":"Not applicable"}]
// Q-M2401_INTRVTN_SMRY_PRSULC_PRVN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"No"},{"value":"01","label":"Yes"},{"value":"NA","label":"Not applicable"}]
// Q-M2401_INTRVTN_SMRY_PRSULC_WET-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"No"},{"value":"01","label":"Yes"},{"value":"NA","label":"Not applicable"}]
